// Datos de los pasos del onboarding
import { Bot, Workflow, MousePointerClick, Rocket } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface OnboardingStepData {
  icon: LucideIcon;
  title: string;
  description: string;
  items: string[];
}

export const onboardingSteps: OnboardingStepData[] = [
  {
    icon: Bot,
    title: '¿Qué es ProcesoFácil?',
    description:
      'Una herramienta de automatización robótica de procesos que te permite automatizar tareas repetitivas en Windows — sin necesidad de programar.',
    items: [
      'Automatiza aplicaciones de escritorio y web',
      'Diseña flujos visualmente con drag & drop',
      'Ideal para tareas repetitivas con datos de Excel',
    ],
  },
  {
    icon: Workflow,
    title: '¿Cómo funciona?',
    description:
      'El proceso es simple: diseñas un workflow en el editor visual, conectas el agente en tu PC y lo ejecutas.',
    items: [
      '1. Diseña tu workflow en el editor visual',
      '2. Conecta el agente instalado en tu PC',
      '3. Ejecuta y observa la automatización en acción',
    ],
  },
  {
    icon: MousePointerClick,
    title: '¿Qué puedo automatizar?',
    description:
      'Prácticamente cualquier tarea repetitiva que hagas manualmente en tu computadora.',
    items: [
      'Hacer clic en botones y menús',
      'Escribir texto en formularios y campos',
      'Procesar filas de archivos Excel/CSV en loops',
      'Tomar decisiones con condiciones (Si/Sino)',
      'Abrir aplicaciones y navegar en el navegador',
    ],
  },
  {
    icon: Rocket,
    title: 'Primeros pasos',
    description: 'Para comenzar a automatizar, sigue estos pasos:',
    items: [
      'Descarga e instala el agente desde la sección "Descargas"',
      'Configura la URL del agente y tu API Key en "Configuración"',
      'Crea tu primer workflow desde el botón "Crear Workflow"',
      'Consulta la "Guía" en el menú lateral para más detalles',
    ],
  },
];
